module.exports = __webpack_public_path__ + "img/coefficient.926ef790.png";